module.exports = __webpack_public_path__ + "static/media/rsz_stfcapcom.85859412.webp";